export default __webpack_public_path__ + "static/media/2019-5.6fcde2c3.jpeg";